import { Stack } from '@mui/material'
import { useRoutes } from '../../hooks/useRoutes.js'
import { useToAddressRequirements } from '../../hooks/useToAddressRequirements.js'
import { useWideVariant } from '../../hooks/useWideVariant.js'
import { useFieldActions } from '../../stores/form/useFieldActions.js'
import { useFieldValues } from '../../stores/form/useFieldValues.js'
import type { CardProps } from '../Card/Card.js'
import { RouteNotFoundCard } from '../RouteCard/RouteNotFoundCard.js'
import {
  RouteProviderCard,
  RouteProviderCardSkeleton,
} from '../RouteCard/RouteProviderCard.js'

export const LimitOrderRoutes: React.FC<CardProps> = (props) => {
  const { routes, issues, isLoading, isFetching, isFetched } = useRoutes()
  const [toAddress, selectedRouteId] = useFieldValues(
    'toAddress',
    'selectedRouteId'
  )
  const { setFieldValue } = useFieldActions()
  const wideVariant = useWideVariant()
  const { requiredToAddress, unsupportedReceiverBlocking } =
    useToAddressRequirements()

  const currentRoute = routes?.[0]

  // Nothing of its own to show: the panel carries the card in the wide layout,
  // and an empty Stack would still take its bottom margin.
  if (
    (!currentRoute && !isLoading && !isFetching && !isFetched) ||
    (wideVariant && !currentRoute && !isLoading)
  ) {
    return null
  }

  const toAddressUnsatisfied =
    currentRoute &&
    (unsupportedReceiverBlocking || (requiredToAddress && !toAddress))
  const allowInteraction = !toAddressUnsatisfied

  const activeRouteId =
    routes?.find((route) => route.id === selectedRouteId)?.id ??
    currentRoute?.id

  return (
    <Stack
      direction="column"
      spacing={1}
      sx={props.sx}
      className={props.className}
    >
      {isLoading && !currentRoute ? (
        Array.from({ length: 2 }).map((_, index) => (
          <RouteProviderCardSkeleton key={index} />
        ))
      ) : !currentRoute ? (
        // The side panel carries the card in the wide layout, where it showed
        // twice. The route selector below stays either way.
        wideVariant ? null : (
          <RouteNotFoundCard issues={issues} />
        )
      ) : (
        routes?.map((route) => (
          <RouteProviderCard
            key={route.id}
            route={route}
            active={route.id === activeRouteId}
            onClick={
              allowInteraction
                ? () => setFieldValue('selectedRouteId', route.id)
                : undefined
            }
          />
        ))
      )}
    </Stack>
  )
}
